import { render, staticRenderFns } from "./body.vue?vue&type=template&id=5e46d276&scoped=true&lang=pug&"
import script from "./body.vue?vue&type=script&lang=js&"
export * from "./body.vue?vue&type=script&lang=js&"
import style0 from "./body.vue?vue&type=style&index=0&id=5e46d276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e46d276",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928165100%2Fcomponents%2Fsite%2Fblog%2Farticle%2Fbody.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/image.vue').default,SiteBlogArticleAuthor: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/site/blog/article/author.vue').default,SiteBlogArticleSocial: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/site/blog/article/social.vue').default,WidgetsSocialFbComments: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/social/fb-comments.vue').default})
